'use client'

import { Box, Typography } from '@mui/material';
import { useLabels } from '@/utils/i18n';
import NextLink from 'next/link';
import Image from 'next/image';

export function MenuLogo() {
  const labels = useLabels();
  return (
    <NextLink href="/" passHref legacyBehavior>
      <Box sx={{ display: 'flex', alignItems: 'center', mr: 4, cursor: 'pointer', textDecoration: 'none' }} component="a">
        <Box sx={{ width: 32, height: 32, position: 'relative', mr: 1.5 }}>
          <Image
            src="/logo.svg"
            alt="Kibon Consulting Logo"
            fill
            style={{ objectFit: 'contain' }}
          />
        </Box>
        <Typography
          variant="h6"
          component="div"
          sx={{
            fontWeight: 700,
            letterSpacing: '-0.5px',
            color: 'primary.main',
            fontSize: '1.35rem',
          }}
        >
          {labels.brand.name}
        </Typography>
      </Box>
    </NextLink>
  );
} 